import { render, staticRenderFns } from "./EventTagMenu.vue?vue&type=template&id=3e14ec9a&scoped=true"
import script from "./EventTagMenu.vue?vue&type=script&lang=js"
export * from "./EventTagMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e14ec9a",
  null
  
)

export default component.exports